/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Download_StartedInputs */

const en_file_download_started = /** @type {(inputs: File_Download_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download started`)
};

const nl_file_download_started = /** @type {(inputs: File_Download_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download gestart`)
};

/**
* | output |
* | --- |
* | "Download started" |
*
* @param {File_Download_StartedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const file_download_started = /** @type {((inputs?: File_Download_StartedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Download_StartedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_file_download_started(inputs)
	return en_file_download_started(inputs)
});